import React, { useState } from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import PageLayout from '../components/PageLayout';
import FormInput from '../components/FormInput';
import NavigationButtons from '../components/NavigationButtons';
import { normalizeWeight, validateWeight } from '../utils/signupValidation';

const OnboardingWeight = () => {
  const { formData, updateField } = useOnboarding();
  const [error, setError] = useState('');

  const handleNext = () => {
    const err = validateWeight(formData.weight);
    if (err) { setError(err); return false; }
    const n = normalizeWeight(formData.weight);
    updateField('weight', n === null ? '' : String(n));
    return true;
  };

  return (
    <PageLayout step={3}>
      <h2 className="title">Quel est votre poids ?</h2>
      <p className="subtitle">
        Pour connaitre votre indice corporels, cela permet de mieux comprendre
        le fonctionnement de votre corps
      </p>

      {/* `text` + `inputMode` : accepte « 58,5 » au clavier français (cf. OnboardingHeight). */}
      <FormInput
        type="text"
        name="weight"
        inputMode="decimal"
        autoComplete="off"
        maxLength={6}
        placeholder="60"
        value={formData.weight}
        error={error}
        onChange={(e) => { updateField('weight', e.target.value); setError(''); }}
        unit="kg"
      />
      {error && <p className="signup-error">{error}</p>}

      <NavigationButtons
        nextPath="/onboarding/sport"
        prevPath="/onboarding/taille"
        onNext={handleNext}
      />
    </PageLayout>
  );
};

export default OnboardingWeight;
